import { createSettingsParams, SettingsParamType } from '@wix/tpa-settings';

export type DisplaySettingsParams = {
  showHeaderImage: SettingsParamType.Boolean;
  showHeaderTitle: SettingsParamType.Boolean;
  showHeaderDescription: SettingsParamType.Boolean;
  showMenuDescription: SettingsParamType.Boolean;
  showSectionTitle: SettingsParamType.Boolean;
  showSectionDescription: SettingsParamType.Boolean;
  showSectionImage: SettingsParamType.Boolean;
  showMenuDivider: SettingsParamType.Boolean;
  showItemImage: SettingsParamType.Boolean;
  showItemDescription: SettingsParamType.Boolean;
  showItemLabels: SettingsParamType.Boolean;
  showItemFeatured: SettingsParamType.Boolean;
  overrideItemDesign: SettingsParamType.Boolean;
};

export const displaySettingsParams =
  createSettingsParams<DisplaySettingsParams>({
    showHeaderImage: {
      type: SettingsParamType.Boolean,
      getDefaultValue: () => true,
    },
    showHeaderTitle: {
      type: SettingsParamType.Boolean,
      getDefaultValue: () => true,
    },
    showHeaderDescription: {
      type: SettingsParamType.Boolean,
      getDefaultValue: () => true,
    },
    showMenuDescription: {
      type: SettingsParamType.Boolean,
      getDefaultValue: () => true,
    },
    showSectionTitle: {
      type: SettingsParamType.Boolean,
      getDefaultValue: () => true,
    },
    showSectionDescription: {
      type: SettingsParamType.Boolean,
      getDefaultValue: () => true,
    },
    showSectionImage: {
      type: SettingsParamType.Boolean,
      getDefaultValue: () => true,
    },
    showMenuDivider: {
      type: SettingsParamType.Boolean,
      getDefaultValue: () => true,
    },
    showItemImage: {
      type: SettingsParamType.Boolean,
      getDefaultValue: () => true,
    },
    showItemDescription: {
      type: SettingsParamType.Boolean,
      getDefaultValue: () => true,
    },
    showItemLabels: {
      type: SettingsParamType.Boolean,
      getDefaultValue: () => true,
    },
    showItemFeatured: {
      type: SettingsParamType.Boolean,
      getDefaultValue: () => true,
    },
    overrideItemDesign: {
      type: SettingsParamType.Boolean,
      getDefaultValue: () => false,
    },
  });
